import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import GetClinicSummary from "./GetClinicSummary";
import SummaryView from "./SummaryView";
import { PracticeLocation } from "../../utils/kinshipTypes";
import {
  getClinicSummaryLLM,
  getVeterinarySpecialists,
} from "../../utils/back4AppApi";
import { Document, Packer, Paragraph } from "docx";
import { saveAs } from "file-saver";
import { getFormatedClinicInfo, getPhoneClinicInfo } from "../../utils/utils";

export default function ClinicSummary() {
  const [practiceLocations, setPracticeLocations] = useState<
    PracticeLocation[]
  >([]);
  const [selectedClinic, setSelectedClinic] = useState<string>("");
  const [clinicInfoStr, setClinicInfoStr] = useState<string>("");
  const [summaryText, setSummaryText] = useState<string>("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const res = await getVeterinarySpecialists("linnaeus", "");
      const locations = res.data as PracticeLocation[];
      const uniqueLocations = locations.filter(
        (loc, idx, arr) =>
          arr.findIndex(
            l => l.vetstoriaClinicHash === loc.vetstoriaClinicHash
          ) === idx
      );
      setPracticeLocations(uniqueLocations);
    })();
  }, []);

  useEffect(() => {
    if (selectedClinic) {
      setClinicInfoStr(
        getFormatedClinicInfo(selectedClinic, practiceLocations)
      );
    } else {
      setClinicInfoStr("");
    }
  }, [selectedClinic, practiceLocations]);

  const onGetSummary = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (!selectedClinic) return;

    setLoading(true);
    try {
      const phone = getPhoneClinicInfo(practiceLocations, selectedClinic);
      const res = await getClinicSummaryLLM(selectedClinic, phone);
      setSummaryText(`${clinicInfoStr} ${res.data.infered_text}`);
    } catch (err: any) {
      console.error(
        "Failed to fetch clinic summary:",
        err.response?.data || err
      );
    } finally {
      setLoading(false);
    }
  };

  const onDownload = async () => {
    const fullText = summaryText;
    const paragraphs = fullText.split("\n").map(line => new Paragraph(line));
    const doc = new Document({
      sections: [{ properties: {}, children: paragraphs }],
    });
    const blob = await Packer.toBlob(doc);
    saveAs(blob, `clinic-${selectedClinic}-summary.docx`);
  };

  return (
    <Box>
      <GetClinicSummary
        clinics={practiceLocations}
        selectedClinic={selectedClinic}
        onChangeClinic={setSelectedClinic}
        onGetSummary={onGetSummary}
        loading={loading}
      />

      <SummaryView
        markdown={summaryText}
        loading={loading}
        onDownload={onDownload}
      />
    </Box>
  );
}
